import type { WorkspaceId } from '../models/orpheus.types'

import type { ApiErrorKind } from '@/shared/http'

export type OrpheusTurnFailureState =
  'reconnectable-error' | 'terminal-error' | 'credit-refresh-error'

/** Deliberately excludes prompt, response, error detail, fields, and payload. */
export interface OrpheusTurnFailureEvent {
  state: OrpheusTurnFailureState
  turnId: string
  workspaceId: WorkspaceId
  kind: ApiErrorKind
  status: number | null
  code: string | null
}

export type OrpheusTurnFailureReporter = (event: OrpheusTurnFailureEvent) => void

let reporter: OrpheusTurnFailureReporter = () => {}

export function registerOrpheusTurnFailureReporter(next: OrpheusTurnFailureReporter): () => void {
  reporter = next
  return () => {
    if (reporter === next) reporter = () => {}
  }
}

export function reportOrpheusTurnFailure(event: OrpheusTurnFailureEvent): void {
  try {
    reporter(event)
  } catch {
    // Telemetry must never perturb the user turn.
  }
}
